import React, { useState } from "react";
import {
Progress,
Modal,
ModalBody,
Nav,
NavItem,
NavLink
} from "reactstrap";
import {
Accordion,
AccordionItem,
AccordionItemHeading,
AccordionItemButton,
AccordionItemPanel
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import Header from "../../Layout/Header/Header-loggedIn";

// import Footer from "../Footer/Footer";
import Hint from "../../Components/Hint/Hint";
import HintPack from "../../Components/Hint-Pack/HintPack";
import bgImage from "../../../Assets/img/866-536x354.jpg";
import Group615 from "../../../Assets/img/Group 615.svg";
import Group648 from "../../../Assets/img/Group 648.svg";
import Group649 from "../../../Assets/img/Group 649.svg";
import Group651 from "../../../Assets/img/Group 651.svg";
import list1 from "../../../Assets/img/image.svg";
import list2 from "../../../Assets/img/positive-thinking.svg";
import list3 from "../../../Assets/img/visibility.svg";
import list4 from "../../../Assets/img/surface1.svg";
import list5 from "../../../Assets/img/lock.svg";
import list6 from "../../../Assets/img/scrabble.svg";
import Rectangle from "../../../Assets/img/Rectangle 748.png";
import Heart from "../../../Assets/img/Union 2.svg";
// import FirstNotification from "../../../Assets/img/Group 2307.svg";
// import Close from "../../../Assets/img/Group 2324.svg";
import CloseSource from "../../../Assets/img/Group 2523.svg";
import Timer from "react-compound-timer";
const LevelPageOrginal = props => {
const [modal, setModal] = useState(false);
// const [modalSource, setModalSource] = useState(false);
// const [modalPopup, setModalPopup] = useState(false);
const [hint1, setHint1] = useState(false);
const [hint2, setHint2] = useState(false);
const [hint3, setHint3] = useState(false);
// const toggleSource = () => setModalSource(!modalSource);
const [hintPack, sethintPack] = useState(false);
const toggleHint1 = () => {
if (hint1 === true) {
setHint1(false);
setHint2(false);
setHint3(false);
} else {
setHint1(true);
setHint2(false);
setHint3(false);
}
};
const toggleHint2 = () => {
if (hint2 === true) {
setHint1(false);
setHint2(false);
setHint3(false);
} else {
setHint1(false);
setHint2(true);
setHint3(false);
}
};
const toggleHint3 = () => {
if (hint3 === true) {
setHint1(false);
setHint2(false);
setHint3(false);
} else {
setHint3(true);
setHint1(false);
setHint2(false);
}
};
const toggleCart = () => {
if (hint2 === true && hint1 === true && hint3 === true) {
setHint1(false);
setHint2(false);
setHint3(false);
} else {
setHint1(true);
setHint2(true);
setHint3(true);
}
};
const toggleHintPack = () => sethintPack(!hintPack);
const toggle = () => setModal(!modal);
// const togglePopup = () => setModalPopup(!modalPopup);
const externalCloseBtn = (
<div
className="avatar-circle-30px"
style={{ position: "absolute", top: "50%", left: "315px" }}
>
<span className="initials">
<button
className="close"
style={{ position: "absolute", top: "-4px", left: "-10px" }}
onClick={toggle}
>
<i class="fas fa-angle-double-left"></i>
</button>
</span>
</div>
);
/* ======== desktop view ====================================
==============================================================*/ 
return (
<div className="innerBody d-none d-xl-block">
<Header />
<div className="container mt-2 levelpage mb-5">
<div className="row d-flex align-items-stretch">
   <div className="col-2">
      <div className="top-area">
         <ul className="nav navbar-nav">
            <li className="dropdown mt-2">
               <a
                  href="/"
                  className="dropdown-toggle chapter-text"
                  data-toggle="dropdown"
                  >
               Chapter 1 - level 24
               <i className="fas fa-chevron-down ml-2"></i>
               </a>
               <ul className="dropdown-menu keep-open">
                  <li>
                     <Accordion>
                        <AccordionItem>
                           <AccordionItemHeading>
                              <AccordionItemButton>Chapter 1</AccordionItemButton>
                           </AccordionItemHeading>
                           <AccordionItemPanel>
                              <Nav vertical pills>
                                 <NavItem>
                                    <NavLink href="/" active>
                                       Level 1
                                    </NavLink>
                                 </NavItem>
                                 <NavItem>
                                    <NavLink href="/">Level 2</NavLink>
                                 </NavItem>
                                 <NavItem>
                                    <NavLink href="/">Level 3</NavLink>
                                 </NavItem>
                                 <NavItem>
                                    <NavLink href="/">Level 1</NavLink>
                                 </NavItem>
                                 <NavItem>
                                    <NavLink href="/">Level 2</NavLink>
                                 </NavItem>
                                 <NavItem>
                                    <NavLink href="/">Level 3</NavLink>
                                 </NavItem>
                              </Nav>
                           </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                           <AccordionItemHeading>
                              <AccordionItemButton>Chapter 2</AccordionItemButton>
                           </AccordionItemHeading>
                           <AccordionItemPanel>
                              <Nav vertical pills>
                                 <NavItem>
                                    <NavLink href="/" active>
                                       Level 1
                                    </NavLink>
                                 </NavItem>
                                 <NavItem>
                                    <NavLink href="/">Level 2</NavLink>
                                 </NavItem>
                                 <NavItem>
                                    <NavLink href="/">Level 3</NavLink>
                                 </NavItem>
                                 <NavItem>
                                    <NavLink href="/">Level 1</NavLink>
                                 </NavItem>
                                 <NavItem>
                                    <NavLink href="/">Level 2</NavLink>
                                 </NavItem>
                                 <NavItem>
                                    <NavLink href="/">Level 3</NavLink>
                                 </NavItem>
                              </Nav>
                           </AccordionItemPanel>
                        </AccordionItem>
                     </Accordion>
                  </li>
               </ul>
            </li>
         </ul>
      </div>
      <div className="card icon-list mt-fix-5">
         <h3 className="skills-text mt-1 ml-2">Skills Required</h3>
         <ul className="list-group">
            <li className="list-group-item align-items-center p-0 mt-2">
               <div className="media">
                  <div className="media-left">
                     <div className="avatar-circle-30px">
                        <span className="initials initials-img">
                        <img
                           className="media-object pl-1"
                           src={list1}
                           alt="..."
                           />
                        </span>
                     </div>
                  </div>
                  <div className="media-body list-text ml-2">
                     iMAGE rEVERSAL sEARCH SKILL
                  </div>
               </div>
            </li>
            <li className="list-group-item align-items-center p-0 mt-3">
               <div className="media">
                  <div className="media-left">
                     <div className="avatar-circle-30px">
                        <span className="initials initials-img">
                        <img className="media-object" src={list2} alt="..." />
                        </span>
                     </div>
                  </div>
                  <div className="media-body list-text ml-2">
                     SIMPLE APTITUDE
                  </div>
               </div>
            </li>
            <li className="list-group-item align-items-center p-0 mt-3">
               <div className="media">
                  <div className="media-left">
                     <div className="avatar-circle-30px">
                        <span className="initials initials-img">
                        <img className="media-object" src={list3} alt="..." />
                        </span>
                     </div>
                  </div>
                  <div className="media-body list-text ml-2">Hidden File</div>
               </div>
            </li>
            <li className="list-group-item align-items-center p-0 mt-3">
               <div className="media">
                  <div className="media-left">
                     <div className="avatar-circle-30px">
                        <span className="initials initials-img">
                        <img className="media-object" src={list4} alt="..." />
                        </span>
                     </div>
                  </div>
                  <div className="media-body list-text ml-2">
                     URL manipulation
                  </div>
               </div>
            </li>
            <li className="list-group-item align-items-center p-0 mt-3">
               <div className="media">
                  <div className="media-left">
                     <div className="avatar-circle-30px">
                        <span className="initials initials-img">
                        <img className="media-object" src={list5} alt="..." />
                        </span>
                     </div>
                  </div>
                  <div className="media-body list-text ml-2">
                     Cipher Breaking
                  </div>
               </div>
            </li>
            <li className="list-group-item align-items-center p-0 mt-3">
               <div className="media">
                  <div className="media-left">
                     <div className="avatar-circle-30px">
                        <span className="initials initials-img">
                        <img className="media-object" src={list6} alt="..." />
                        </span>
                     </div>
                  </div>
                  <div className="media-body list-text ml-2">Word Play</div>
               </div>
            </li>
         </ul>
         <div className="border-top-list" />
            <div className="analytic-area mt-2">
               <h4 className="complexity-text">
                  Complexity <span className="custom-red ml-2">70/100</span>
               </h4>
               <Progress value="1" color="custom-red" max="5" />
            </div>
            <div className="analytic-area">
               <h4 className="complexity-text">
                  Success rate <span className="custom-green ml-2">80/100</span>
               </h4>
               <Progress value="1" color="custom-green" max="5" />
            </div>
         </div>
      </div>
      <div className="col-8">
         <div className="d-flex align-content-center top-area">
            <div className="pl-0 pt-2 pb-2 pr-2">
               <img src={Group615} className="group-img" alt="" />
            </div>
            <div className="col-12 d-flex">
               <div className="pl-2 pt-2 pb-2 pr-0 flex-grow-1">
                  <Progress multi>
                  <Progress bar color="custom" value="25"></Progress>
                  </Progress>
                  <div className="progress-icon d-flex">
                     <img
                        src={Group648}
                        onClick={toggleHint1}
                        className="icon1 group-img hand"
                        alt=""
                        />
                     <img
                        src={Group649}
                        onClick={toggleHint2}
                        className="icon2 group-img"
                        alt=""
                        />
                     <img
                        src={Group649}
                        onClick={toggleHint3}
                        className="icon3 group-img"
                        alt=""
                        />
                  </div>
               </div>
               <div className="col-1 text-right">
                  <div className="icon4 avatar-circle-xsm">
                     <span className="timers">
                        <Timer
                           initialTime={600000}
                           startImmediately={true}
                           direction="backward" className={''}
                           >
                           {() => (
                           <div className="">
                              <React.Fragment>
                                 <Timer.Minutes />
                                 : 
                                 <Timer.Seconds />
                              </React.Fragment>
                           </div>
                           )}
                        </Timer>
                     </span>
                  </div>
               </div>
            </div>
         </div>
         <div className="mt-fix-10 card shadow-0 border-0 text-white text-center">
            {hintPack ? (
            <HintPack />
            ) : (
            <div>
               <img
                  src={bgImage}
                  alt=""
                  className="card-img img-scale main-image"
                  />
               <div className="card-img-overlay d-flex align-items-center p-0">
                  {hint1 ? 
                  <Hint />
                  : null}
                  {hint2 ? 
                  <Hint />
                  : null}
                  {/* 
                  <div className="d-flex flex-column bd-highlight mb-3">
                     {hint1 ? 
                     <Hint />
                     : null}
                     {hint2 ? 
                     <Hint />
                     : null}
                     {hint3 ? 
                     <Hint />
                     : null}
                  </div>
                  */}
               </div>
            </div>
            )}
            {/* 
            <HintPack />
            */}
         </div>
         <div className="card card-black mt-3">
            <p className="mb-1">
               Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
               diam nonumy eirmod tempor invidunt ut labore et dolore magna
               aliquyam erat, sed diam voluptua. At vero eos et accusam et
               justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea
               takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum
               dolor sit
            </p>
         </div>
         <div id="source-code"> 
            <a href="#/" id="x"><img src={CloseSource} alt="close" /></a>
         </div>
      </div>
      <div className="col-2">
         <div className="top-area">
            <img
               src={Group651}
               className="cart"
               onClick={toggleCart}
               alt=""
               />
            <button
               className="btn btn-yellow ml-4"
               type="submit"
               onClick={toggleHintPack}
               >
            <img src={Heart} className="btn-icon mr-1" alt="" />
            Buy hint
            </button>
         </div>
         <div className="card recent-answers mt-fix-10">
            <h3 className="skills-text mt-1 ml-2">recent answers</h3>
            <ul className="list-group headline mb-5">
               <li className="list-group-item">Lorem ipsum dolor sit am</li>
               <li className="list-group-item">Lorem ipsum dolor sit am</li>
               <li className="list-group-item">Lorem ipsum dolor sit am</li>
               <li className="list-group-item">Lorem ipsum dolor sit am</li>
            </ul>
            <div className="border-top-list" />
               <a className="btn btn-yellow" href="#source-code" id="view-source">View Source</a>
               <img src={Rectangle} className="mt-2" alt="" />
            </div>
         </div>
      </div>
      <div className="footer-answer d-flex justify-content-center">
         <form className="form-inline">
            <div className="form-group mx-sm-3 mb-2">
               <label htmlFor="inputPassword2" className="sr-only">
               Answer here
               </label>
               <input
                  type="text"
                  className="form-control"
                  id="inputPassword2"
                  placeholder="Answer here"
                  />
            </div>
            <button type="submit" className="btn mb-2">
            SUBMIT
            </button>
         </form>
      </div>
      
      <button onClick={toggle} className="btn Leaderboard btn-yellow">
      Leaderboard
      </button>
      <Modal
         isOpen={modal}
         toggle={toggle}
         backdrop={false}
         className="left"
         external={externalCloseBtn}
         >
         <ModalBody>
            <table className="table  table-dark table-hover">
               <tbody>
                  <tr>
                     <td>#1</td>
                     <td>James Cole</td>
                     <td>Level 320</td>
                  </tr>
                  <tr>
                     <td>#1</td>
                     <td>James Cole</td>
                     <td>Level 320</td>
                  </tr>
                  <tr>
                     <td>#1</td>
                     <td>James Cole</td>
                     <td>Level 320</td>
                  </tr>
                  <tr>
                     <td>#1</td>
                     <td>James Cole</td>
                     <td>Level 320</td>
                  </tr>
               </tbody>
            </table>
         </ModalBody>
      </Modal>
   </div>
</div>
);
};
export default LevelPageOrginal;